import {
  API,
  Request
} from '@/lib/index.js'
import {setIds} from './service'

let setState = (leftNavList, openIds) => {
  if (!leftNavList || !leftNavList.length) {
    return
  }
  for (var i = 0; i < leftNavList.length; i++) {
    let item = leftNavList[i]
    if (openIds.includes(item.categoryId)) {
      item.isOpen = true
    }
    setState(item.children, openIds)
  }
}

export default {
  namespaced: true,
  state: {
    leftNavList: [],
    openIds: [],
    getChildrenFn: null,
    noticeList: [],
    noticeRootCategoryId: 0,
    categoryIdFn: null,
    phrase: '',
    page: 'Rule', // Rule or Notice
    ruleCounts: []
  },
  mutations: {
    updatePage (state, page = 'Rule') {
      state.page = page
    },
    updateLeftNavList (state, payload) {
      state.leftNavList = payload
    },
    setOpenIds (state, {rootState}) {
      // console.log(2223, state, rootState, state.leftNavList)
      let openIds = null
      // state.openIds = findIds(state.leftNavList)
      let findIds = (leftNavList, childCategoryId) => {
        if (!leftNavList || !leftNavList.length) {
          return
        }
        for (var i = 0; i < leftNavList.length; i++) {
          if (openIds) {
            break
          }
          let item = leftNavList[i]
          if (childCategoryId) {
            if (item.ids.includes(childCategoryId)) {
              openIds = item.ids
            } else {
              findIds(item.children, childCategoryId)
            }
          } else if (state.page === 'Rule') {
            if (item.hasRules) {
              openIds = item.ids
            } else {
              findIds(item.children, childCategoryId)
            }
          }
        }
      }
      findIds(state.leftNavList, parseInt(rootState.childCategoryId))
      state.openIds = openIds || []
      setState(state.leftNavList, state.openIds)
      if (!rootState.childCategoryId && state.page === 'Rule' && state.openIds.length) {
        rootState.childCategoryId = state.openIds[state.openIds.length - 1]
      }
    },
    updateOpenIds (state, payload) {
      state.openIds = payload.openIds
      setState(state.leftNavList, payload.openIds)
    },
    updateNoticeList (state, payload) {
      state.noticeList = payload.noticeList
    },
    updateNoticeRootCategoryId (state, id) {
      state.noticeRootCategoryId = id
    },
    refreshFn (state) {
      state.getChildrenFn = null
    },
    updatePhrase (state, phrase) {
      state.phrase = phrase
    },
    goSearch (state, phrase) {
      state.phrase = phrase
    },
    print (state, desc) {
      console.log(state, desc)
    },
    upRuleCounts (state, payload) {
      state.ruleCounts = payload
    },
    increment (state) {
      state.page += state.page
    }
  },
  getters: {
    getPage (state) {
      return state.page
    }
  },
  actions: {
    getChildren ({state, commit, rootState}) {
      // console.log(555, state, rootState, rootState.categoryId)
      state.getChildrenFn = new Promise((resolve, reject) => {
        Request(API.getCategoryNode, {
          categoryId: rootState.categoryId || ''
        }).then((resp) => {
          let result = resp || null
          if (result) {
            result = [result]
          }
          result = result.map((item) => {
            setIds([], item)
            return item
          })
          commit('updateLeftNavList', result)
          resolve(result)
          // console.log(555, state, rootState, rootState.categoryId)
        }).catch(() => {
          reject(false)
        })
      })
      return state.getChildrenFn
    },
    setOpenIds ({commit, rootState}) {
      commit('setOpenIds', {
        rootState
      })
    },
    getRuleOverviewCount ({commit}, childCategoryId) {
      return new Promise((resolve) => {
        Request(API.getRuleOverviewCount, {
          categoryId: childCategoryId
        }).then((resp) => {
          let result = resp || 0
          resolve(result)
          commit('print', 'getRuleOverviewCount',result)
        }).catch(() => {
          resolve(0)
        })
      })
    },
    getRuleOverviews ({commit, rootState, dispatch}, payload) {
      const {
        pageNo,
        pageSize
      } = payload
      return new Promise((resolve, reject) => {
        if (!rootState.childCategoryId) {
          commit('updateNoticeList', {
            noticeList: []
          })
          resolve([])
          return
        }
        let func = dispatch('getRuleOverviewCount', rootState.childCategoryId)
        Request(API.getRuleOverviews, {
          categoryId: rootState.childCategoryId,
          page: {
            pageNo,
            pageSize
          }
        }).then((resp) => {
          let result = resp || []
          commit('updateNoticeList', {
            noticeList: result
          })
          Promise.all([func]).then((item) => {
            resolve({
              list: result,
              total: item[0] || result.length
            })
          })
        }).catch((resp) => {
          reject(resp)
        })
      })
    },
    getNoticeOverviewCount ({commit}, childCategoryId) {
      return new Promise((resolve) => {
        Request(API.getNoticeOverviewCount, {
          categoryId: childCategoryId
        }).then((resp) => {
          let result = resp || 0
          resolve(result)
          commit('print', 'getRuleOverviewCount',result)
        }).catch(() => {
          resolve(0)
        })
      })
    },
    getNoticeOverview ({commit, rootState, dispatch}, payload) {
      const {
        pageNo,
        pageSize,
        categoryId
      } = payload
      return new Promise((resolve, reject) => {
        let func = dispatch('getNoticeOverviewCount', categoryId || rootState.childCategoryId || null)
        Request(API.getNoticeOverview, {
          categoryId: (categoryId || rootState.childCategoryId || null),
          page: {
            pageNo,
            pageSize
          }
        }).then((resp) => {
          const result = resp || []
          commit('updateNoticeList', {
            noticeList: result
          })
          Promise.all([func]).then((item) => {
            resolve({
              list: result,
              total: item[0] || result.length
            })
          })
        }).catch((resp) => {
            reject(resp)
        })
      })
    },
    async getNoticeRootCategoryId ({state, commit}) {
      state.categoryIdFn = new Promise((resolve, reject) => {
        Request(API.getNoticeRootCategoryId, {}).then((resp) => {
          commit('updateNoticeRootCategoryId', resp)
          resolve(resp)
        }).catch(() => {
          reject(false)
        })
      })
      return state.categoryIdFn
    },
    search ({state, commit, dispatch}, payload) {
      const {
        pageNo,
        pageSize,
        categoryIds
        // phrase
      } = payload
      return new Promise((resolve, reject) => {
        Request(API.search, {
          condition: {
            keyPhraseDto: {
              phrase: state.phrase
            },
            categoryIds,
            page: {
              pageNo,
              pageSize
            }
          }
        }).then((resp) => {
          const result = resp || {}
          console.log('search', result)
          let ruleOverviews = result.ruleOverviews || []
          let highlightWords = result.highlight && result.highlight.highlightWords || []
          ruleOverviews = ruleOverviews.map((item) => {
            highlightWords.forEach((item2) => {
              let reg = new RegExp(item2, 'g')
              item.title = item.title.replace(reg, function ($$) {
                return `<em>${$$}</em>`
              })
            })
            return item
          })
          let func = dispatch('searchStatistics')
          Promise.all([func]).then((item) => {
            commit('updateNoticeList', {
              noticeList: ruleOverviews
            })
            resolve({
              list: result,
              total: item[0] || ruleOverviews.length
            })
          })
        }).catch((resp) => {
            reject(resp)
        })
      })
    },
    searchStatistics ({ state, commit }) {
      return new Promise((resolve) => {
        Request(API.searchStatistics, {
          keyPhraseDto: {
            phrase: state.phrase
          }
        }).then((resp) => {
          let result = resp || {}
          const ruleCounts = result.ruleCounts || []
          console.log('categoryFirst', resp)
          ruleCounts.unshift({
            category: {
              categoryId: 0,
              name: '全部'
            },
            count: result.totalCount || 0
          })
          commit('upRuleCounts', ruleCounts)
          resolve(ruleCounts)
        }).catch(() => {
          resolve([])
        })
      })
    },
    incrementIfOddOnRootSum ({ state, commit, rootState }) {
      if ((state.count + rootState.count) % 2 === 1) {
        commit('increment')
      }
    }
  }
}
